import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useI18n } from '@/contexts/I18nContext';
import { User, Home } from 'lucide-react';
import socialMattIcon from '@/assets/icons/social_matt.svg';
import searchIcon from '@/assets/icons/search.svg';
import calendarIcon from '@/assets/icons/calendar.svg';
import signInIcon from '@/assets/icons/sign_in.svg';
import { SearchIcon } from '../icons/SearchIcon';
import { CalendarIcon } from '../icons/CalendarIcon';

export const BottomNavigation = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useI18n();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const navigationItems = [
    {
      name: 'Home',
      originalName: 'home',
      icon: null,
      href: '/home',
      current: location.pathname === '/home',
      isHome: true,
    },
    {
      name: t('navigation.social_matt'),
      originalName: 'social_matt',
      icon: socialMattIcon,
      href: '/social',
      current: location.pathname === '/social',
    },
    {
      name: t('navigation.search'),
      originalName: 'search',
      icon: searchIcon,
      href: '/search',
      current: location.pathname === '/search',
    },
    {
      name: t('navigation.calendar'),
      originalName: 'calendar',
      icon: calendarIcon,
      href: '/calendar',
      current: location.pathname === '/calendar',
    },
    user ? {
      name: t('navigation.profile'),
      originalName: 'profile',
      icon: signInIcon,
      href: '/profile',
      current: location.pathname === '/profile',
      isAvatar: true,
    } : {
      name: t('navigation.sign_in'),
      originalName: 'sign_in',
      icon: signInIcon,
      href: '/',
      current: location.pathname === '/',
      isAvatar: false,
    },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50" style={{ background: 'rgba(40,27,27,0.5)', backdropFilter: 'blur(8px)' }}>
      <div className="max-w-2xl mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          {navigationItems.map((item) => (
            item.isHome ? (
              <button
                key={item.originalName}
                onClick={() => navigate(item.href)}
                className={`flex flex-col items-center justify-center flex-1 h-full min-w-0 ${item.current ? 'text-white' : 'text-white/70 hover:text-white'}`}
              >
                <Home className="w-6 h-6 text-white" />
                <span className="text-xs mt-1">{item.name}</span>
              </button>
            ) : item.isAvatar ? (
              <button key={item.originalName} className={`flex flex-col items-center justify-center flex-1 h-full min-w-0 ${item.current ? 'text-white' : 'text-white/70 hover:text-white'}`} onClick={() => navigate(item.href)}>
                <User className="w-6 h-6 text-white" />
                <span className="text-xs mt-1">{item.name}</span>
              </button>
            ) : item.originalName === 'search' ? (
              <button
                key={item.originalName}
                onClick={() => navigate(item.href)}
                className={`flex flex-col items-center justify-center flex-1 h-full min-w-0 ${item.current ? 'text-white' : 'text-white/70 hover:text-white'}`}
              >
                <img
                  src={searchIcon}
                  alt={item.name}
                  className="w-6 h-6"
                />
                <span className="text-xs mt-1">{item.name}</span>
              </button>
            ) : item.originalName === 'calendar' ? (
              <button
                key={item.originalName}
                onClick={() => navigate(item.href)}
                className={`flex flex-col items-center justify-center flex-1 h-full min-w-0 ${item.current ? 'text-white' : 'text-white/70 hover:text-white'}`}
              >
                <img src={calendarIcon} alt={item.name} className="w-6 h-6" />
                <span className="text-xs mt-1">{item.name}</span>
              </button>
            ) : item.originalName === 'social_matt' ? (
              <button
                key={item.originalName}
                onClick={() => navigate(item.href)}
                className={`flex flex-col items-center justify-center flex-1 h-full min-w-0 ${item.current ? 'text-white' : 'text-white/70 hover:text-white'}`}
              >
                <img src={socialMattIcon} alt={item.name} className="w-6 h-6" />
                <span className="text-xs mt-1">{item.name}</span>
              </button>
            ) : (
              <button
                key={item.originalName}
                onClick={() => navigate(item.href)}
                className={`flex flex-col items-center justify-center flex-1 h-full min-w-0 ${item.current ? 'text-white' : 'text-white/70 hover:text-white'}`}
              >
                <img src={item.icon} alt={item.name} className="w-6 h-6" />
                <span className="text-xs mt-1">{item.name}</span>
              </button>
            )
          ))}
        </div>
      </div>
    </nav>
  );
};
